export const users = {
  INDEX: '/users',
  EDIT: '/users/edit',
  EDIT_USER: '/users/edit/id',
}
